import type NumberUnit from '@exodus/currency';
import { WalletAccount } from '@exodus/models';
import { createSelector } from 'reselect';

export type Balance = {
  balance: NumberUnit;
};

export type AssetBalances = {
  [assetName: string]: Balance;
};

export type StateWithBalances = {
  balances: {
    [walletAccount: string]:
      | {
          loaded: boolean;
          data: AssetBalances;
        }
      | undefined;
  };
};

function getAccountBalances(state: StateWithBalances) {
  return state.balances[WalletAccount.DEFAULT_NAME];
}

export const balancesLoadedSelector = (state: StateWithBalances) => {
  return getAccountBalances(state)?.loaded ?? false;
};

export const balancesSelector = (state: StateWithBalances) => {
  const balances = getAccountBalances(state);
  return balances?.loaded ? balances.data : {};
};

const createAssetBalanceSelector = (assetName: string) =>
  createSelector(
    balancesSelector,
    (balances): NumberUnit | null => balances[assetName]?.balance || null,
  );

export default createAssetBalanceSelector;
